import {forkJoin} from "rxjs";
import {map, first} from "rxjs/operators";
import MenuOptionReducerService from "app/fakeReducer/menuOption.reducer";
import {PricingTypes} from "shared-types/index";
import BookingOptionsManagerService from "app/services/bookingOptionsManager/bookingOptionsManager.service";
import EventsService from 'app/services/events/events.service';
import AdminService from 'external-services/diary-admin-service/admin.service';

const NS = 'MenuOptionsCtrl';

export default function MenuOptionsCtrl($scope, $state, scheduleService, unregister) {
  "ngInject";

  const vm = this;
  let listeners = [];

  vm.savingIds = [];
  vm.errorIds = [];
  vm.currency = AdminService.getVenue()?.currency;

  vm.loading = true;
  vm.error = null;
  vm.items = [];
  vm.PricingTypes = PricingTypes;

  vm.add = add;
  vm.edit = edit;
  vm.itemUpdated = itemUpdated;
  vm.toggleShowArchived = toggleShowArchived;
  vm.archiveUnused = archiveUnused;

  init();

  listeners.push($scope.$watch('vm.searchStr', filterMenuOptions));
  listeners.push($scope.$on('$destroy', () => unregister(listeners)));

  function init() {
    vm.searchStr = '';
    vm.showAllArchived = false;
    vm.showAllArchivedMessage = false;
    vm.includeArchivedInSearch = true;
    vm.archiveLoading = false;

    // if editing booking options we need to clear the cache, so they get reloaded in new/edit booking
    MenuOptionReducerService.clearCachedBookingOptions();

    BookingOptionsManagerService.getAll().then(function (items) {
      vm.items = items;
      vm.loading = false;
      setShowAllArchivedMessage();
    }).catch(function (e) {
      vm.error = e;
      vm.loading = false;
    });
  }

  function filterMenuOptions(val) {
    // console.log(NS, 'filterMenuOptions', val)
    vm.items.forEach(item => {
      item.searchMatched = !val ? null : (
        item.name.toLowerCase().indexOf(val.toLowerCase()) !== -1 ||
        item.label.toLowerCase().indexOf(val.toLowerCase()) !== -1
      )
    });
  }

  function setShowAllArchivedMessage() {
    vm.showAllArchivedMessage = !vm.errorIds.length && !vm.savingIds.length && vm.items.length
      && vm.items.filter(o => o.isArchived).length === vm.items.length;
  }

  function itemUpdated(item) {
    const id = item._id;

    removeSavingId(id);
    vm.savingIds.push(id);

    item.errorMessage = null;

    BookingOptionsManagerService.save(item).then((response) => {

      // need to update the revision id for each update so it can be saved again without conflict
      item._rev = response.rev;

      removeErrorId(id);
      removeSavingId(id);
      setShowAllArchivedMessage();
    }).catch((err) => {
      vm.errorIds.push(id);
      removeSavingId(id);
      setShowAllArchivedMessage();
      console.warn(NS, 'save error', err);
    });
  }

  function removeSavingId(id) {
    const index = vm.savingIds.indexOf(id);
    if (index !== -1) {
      vm.savingIds.splice(index, 1);
    }
  }

  function removeErrorId(id) {
    const index = vm.errorIds.indexOf(id);
    if (index !== -1) {
      vm.errorIds.splice(index, 1);
    }
  }

  function add() {
    $state.go('settings.menuoptions.edit', {
      id: null
    });
  }

  function edit(item) {
    $state.go('settings.menuoptions.edit', {
      id: encodeURIComponent(item._id)
    });
  }

  function toggleShowArchived() {
    vm.showAllArchived = !vm.showAllArchived;
  }

  function archiveUnused() {
    vm.archiveLoading = true;

    forkJoin([
      scheduleService.getActiveMenuOptions(),
      EventsService.getActiveMenuOptions()
    ])
      .pipe(
        map(data => data[0].concat(data[1])),
        first()
      )
      .subscribe(activeParentIds => {

        const allIds = getAllActiveParentAndChildIds(activeParentIds);
        let changedItems = [];

        vm.items.forEach(item => {
          const itemId = item._id;
          const found = allIds.includes(itemId);
          if (!found) {
            if (!item.isArchived) {
              changedItems.push(item);

              removeSavingId(itemId);
              vm.savingIds.push(itemId);
              item.errorMessage = null;
              item.isArchived = true; // set it to archived, so the UI updates
            }
          }
        });

        if (!changedItems.length) {
          vm.archiveLoading = false;
          return;
        }

        bulkSave(changedItems);
      });
  }

  function bulkSave(changedItems) {
    BookingOptionsManagerService.bulkSave(changedItems)
      .then((response) => {
        // need to update the revision id for each update so it can be saved again without conflict
        vm.items.forEach(item => {
          const itemId = item._id;
          const revItem = response.find(r => itemId === r.id);
          if (revItem) {
            item._rev = revItem.rev;

            removeErrorId(itemId);
            removeSavingId(itemId);
          }
        });

        setShowAllArchivedMessage();
        vm.archiveLoading = false;
      }).catch((err) => {
      changedItems.forEach(item => {
        vm.errorIds.push(item._id);
        removeSavingId(item._id);
      });
      setShowAllArchivedMessage();
      vm.archiveLoading = false;
      console.warn(NS, 'bulkSave error', err);
    });
  }

  /**
   * Sorts through activeParentIds and returns theirs ids along with their child ids
   * @param {*} activeParentIds - ids for menu options that exist in services
   */
  function getAllActiveParentAndChildIds(activeParentIds) {
    return vm.items.reduce((acc, item) => {

      // if parent is not active we are not interested in the item
      if (!activeParentIds.includes(item._id)) {
        return acc;
      }

      if (!acc.includes(item._id)) {
        acc.push(item._id);
      }

      if (item.explicitChildMenuOptionIds) {
        item.explicitChildMenuOptionIds.forEach(id => {
          if (!acc.includes(id)) {
            acc.push(id);
          }
        });
      }

      if (item.childMenuOptionIds) {
        item.childMenuOptionIds.forEach(id => {
          if (!acc.includes(id)) {
            acc.push(id);
          }
        });
      }

      return acc;
    }, []);
  }

  /*function remove(event, item) {
      var confirm = $mdDialog.confirm()
          .parent(angular.element(document.body))
          .title('Are you sure?')
          .content('Delete booking option ' + item.name)
          .ariaLabel('Delete booking option')
          .ok('Yes')
          .cancel('No')
          .targetEvent(event);
      $mdDialog.show(confirm).then(function() {
          BookingOptionsManagerService.remove(item).then(function(){
              init();
          });
      });
  }*/
}
